/* Epal front page hero slideshow (sections/epal-home-hero.liquid). Generated by .claude/data/split_homepage.py
   from the old inline script; runs for every [data-epal-hero] with dots, again after a theme-editor reload. */
(function () {
    function epalHero(wrap) {
      if (!wrap || wrap.dataset.epalHeroReady) return
      wrap.dataset.epalHeroReady = '1'
      var track = wrap.querySelector('[data-epal-hero-track]')
      var dotsEl = wrap.querySelector('[data-epal-hero-dots]')
      var panels = [].slice.call(track.children)
      var delay = parseInt(track.getAttribute('data-autoplay'), 10) * 1000
      var timer = null, paused = false, ticking = false
      function current() {
        var best = 0, dist = Infinity
        panels.forEach(function (p, i) { var d = Math.abs(p.offsetLeft - track.scrollLeft); if (d < dist) { dist = d; best = i } })
        return best
      }
      function go(i) {
        i = (i + panels.length) % panels.length
        track.scrollTo({ left: panels[i].offsetLeft, behavior: 'smooth' })
      }
      function stop() { if (timer) { clearInterval(timer); timer = null } }
      var dots = panels.map(function (p, i) {
        var b = document.createElement('button')
        b.type = 'button'
        b.setAttribute('aria-label', 'Mynd ' + (i + 1))
        b.addEventListener('click', function () { stop(); go(i) })
        dotsEl.appendChild(b)
        return b
      })
      function paint() {
        var c = current()
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === c); if (i === c) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current') })
        ticking = false
      }
      track.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(paint) } }, { passive: true })
      wrap.querySelector('[data-epal-hero-prev]').addEventListener('click', function () { stop(); go(current() - 1) })
      wrap.querySelector('[data-epal-hero-next]').addEventListener('click', function () { stop(); go(current() + 1) })
      paint()
      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches
      var editor = window.Shopify && window.Shopify.designMode
      if (track.classList.contains('epal-home__hero--slider') && delay > 0 && !reduced && !editor) {
        timer = setInterval(function () { if (!paused && !document.hidden) go(current() + 1) }, delay)
        wrap.addEventListener('mouseenter', function () { paused = true })
        wrap.addEventListener('mouseleave', function () { paused = false })
        wrap.addEventListener('focusin', function () { paused = true })
        wrap.addEventListener('focusout', function () { paused = false })
        track.addEventListener('touchstart', stop, { passive: true })
      }
      // Theme editor: selecting a panel in the sidebar brings that slide into view.
      document.addEventListener('shopify:block:select', function (e) { var i = panels.indexOf(e.target); if (i > -1) { stop(); go(i) } })
    }
  function init() { document.querySelectorAll('[data-epal-hero]').forEach(function (w) { if (w.querySelector('[data-epal-hero-dots]')) epalHero(w) }) }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init()
  document.addEventListener('shopify:section:load', init)
})();
